<template>
  <v-dialog v-model="mostrar" max-width="500" persistent>
    <v-card>
      <v-toolbar color="primary" dark dense flat
        ><h3>Eliminar sesión</h3>
        </v-toolbar
      >
      <v-container>
        <v-card-title>
          ¿Está seguro de eliminar la sesión?
        </v-card-title>
        <v-card-subtitle>
          Esta acción no se podrá deshacer.
        </v-card-subtitle>
      </v-container>
      <v-divider class="mx-3"></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" small outlined @click="$emit('cancelar')"
          >Cancelar</v-btn
        >
        <v-btn
          color="primary"
          small
          @click="eliminarSesion()"
          >Eliminar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { eliminarSesionService } from "./administrar.service"; 

export default {
  name: "borrarSesionComponent",
  props: ["mostrar", "idSesion", "sesionAbierta"],
  computed: {
    ...mapGetters(["userAdmin"]),
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async eliminarSesion() {
      try {
          this.loading=true;
          const serverResponse = await eliminarSesionService(this.$route.params.idSesion)
          this.loading= false
          if(!serverResponse.ok) throw new Error(serverResponse.mensaje)
          this.$router.push('/main/admin');
        
        }
        catch (error) {
          this.loading= false
          this.$notificarError(error);
        }
    }
  },
};
</script>